// alphatic menu js code start
$(document).ready(function () {
  var stockMsg = $(".current_variant_msg").attr("data-stock-msg");
  $(".custom_property").val(stockMsg);
  $(".alphabet").click(function () {
    var ariaLabel = $(this).attr("aria-label").trim();
    var isActive = $(
      '.alphabet-menu-lower-roww[data-alphabet="' + ariaLabel + '"]'
    ).hasClass("active");
    $(".alphabet-menu-lower-roww").removeClass("active");
    $(".alphabet-menu-lower").removeClass("active");
    if (!isActive) {
      $(
        '.alphabet-menu-lower-roww[data-alphabet="' + ariaLabel + '"]'
      ).addClass("active");
      $(".alphabet-menu-lower").addClass("active");
    }
    var $browseByLetter = $(".browse-by-letter");
    $browseByLetter.text(ariaLabel);
    if (ariaLabel.toLowerCase().includes("other")) {
      $browseByLetter.addClass("other-text");
    } else {
      $browseByLetter.removeClass("other-text");
    }
  });
});
// alphatic menu js code end

// footer link accordion js start
// if (window.matchMedia("(max-width: 749px)").matches) {
//   $(document).ready(function () {
//     $(".footer-block__heading").on("click", function () {
//       $(this)
//         .closest(".footer-block")
//         .toggleClass("active")
//         .find(".footer-block__details-content")
//         .slideToggle();
//     });
//   });
// }

$(document).ready(function () {
  // Function to handle adding or removing event handlers based on screen size
  function handleFooterBlockClick() {
    if (window.matchMedia("(max-width: 749px)").matches) {
      $(".footer-block__heading").off("click").on("click", function () {
        $(this)
          .closest(".footer-block")
          .toggleClass("active")
          .find(".footer-block__details-content")
          .slideToggle();
      });
    } else {
      // Remove the click event handler if the screen is larger than 749px
      $(".footer-block__heading").off("click");
      // Optionally, ensure all content is visible when screen is larger than 749px
      $(".footer-block__details-content").show();
    }
  }

  // Initial call to handle the click events based on the initial screen size
  handleFooterBlockClick();

  // Add an event listener to handle screen resizing
  window.matchMedia("(max-width: 749px)").addEventListener('change', handleFooterBlockClick);
});

// footer link accordion js end

$(document).ready(function () {
  $(".alphabet-menu .browse-alphabetically").on("click", function () {
    var $loops = $(this).siblings(".browse-alphabetically-loops");
    if ($loops.is(":hidden")) {
      $loops.css("display", "flex").hide().slideDown("fast");
      $(this).parent().addClass("active");
    } else {
      $loops.slideUp("fast", function () {
        $(this).css("display", "none");
        $(this).parent().removeClass("active");
      });
    }
  });

  $(".alphabet-menu-close-icon svg").click(function () {
    $(".alphabet-menu-lower").removeClass("active");
  });
});

// custom ajax related products

// $(document).ready(function(){
//   $(document).on('change','.variant-selector', function() {
//     var selectedValue = $(this).val();
//     console.log(selectedValue);
//   });
// });

// $(document).ready(function () {
//   $(document).on('change','.variant-selector', function() {
//     var variant_id = $(this).val();
//     console.log(variant_id);
//     $(document).on('click','.cus-atc-btn-wrapper input:checked' function() {
//       console.log('checkedd');
//       // var variant_quantity = 1
//       // $.ajax({
//       //   type: 'POST',
//       //   url: '/cart/add.js',
//       //   data: {quantity: variant_quantity, id: variant_id},
//       //   dataType: 'json',
//       //   success: function(data){
//       //     console.log(data);
//       //   }
//       // });
//     });
//   });
// });

// $(document).ready(function () {
//   $(document).on('change', '.variant-selector', function() {
//     var variant_id = $(this).val();
//     $(document).on('click', '.cus-atc-btn-wrapper input:checked', function() {
//       console.log(variant_id);
//     });
//   });
// });

// $(document).ready(function () {
//   var currentVariantId = null;
//   $(document).on('change', '.variant-selector', function() {
//     currentVariantId = $(this).val();
//   });
//   $(document).on('change', '.cus-atc-btn-wrapper input:checkbox', function() {
//     if ($(this).is(':checked')) {
//       var $container = $(this).closest('.cus-product-options-with-atc');
//       var $select = $container.find('.variant-selector');
//       var variant_id = $select.val();
//       console.log('Selected Value:', variant_id);
//       var variant_quantity = 1
//       $.ajax({
//         type: 'POST',
//         url: '/cart/add.js',
//         data: {quantity: variant_quantity, id: variant_id},
//         dataType: 'json',
//         success: function(data){
//           console.log(data);
//         }
//       });
//     }
//   });
// });

$(document).ready(function () {
  // Initialize currentVariantId on page load
  var currentVariantId = $(".variant-selector").val();

  // Update currentVariantId when variant selector changes
  $(document).on("change", ".variant-selector", function () {
    currentVariantId = $(this).val();
  });

  // Handle checkbox change events
  $(document).on("change", ".cus-atc-btn-wrapper input:checkbox", function () {
    if ($(this).is(":checked")) {
      var $container = $(this).closest(".cus-product-options-with-atc");
      var $select = $container.find(".variant-selector");
      var variant_id = $select.val();
      console.log("Selected Value:", variant_id);
      var variant_quantity = 1;
      var cartselector =
        document.querySelector("cart-notification") ||
        document.querySelector("cart-drawer");
      $.ajax({
        type: "POST",
        url: "/cart/add.js",
        data: {
          quantity: variant_quantity,
          id: variant_id,
          sections: cartselector
            .getSectionsToRender()
            .map((section) => section.id),
        },
        dataType: "json",
        success: function (data) {
          console.log(data);
          cartselector = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
          cartselector.getSectionsToRender().map((section) => section.id);
          cartselector.renderContents(data);
        },
      });
    }
  });

  $(document).on('click', '.variant-arrow', function(e){
    e.preventDefault();
    const select = $(this).siblings('.variant-selector')[0];
    if (select.showPicker) {
        select.showPicker();
    } else {
        select.focus();
        $(select).trigger('mousedown');
    }
  });
  
});

jQuery(document).ready(function (t) {
    t(".cms-static-page-view .accordion-section-title").click(function () {
        t(this).next(".cms-static-page-view .accordion-section-content").slideToggle("slow").siblings(".cms-static-page-view .accordion-section-content:visible").slideUp("slow"),
            t(this).toggleClass("active"),
            t(this).siblings(".cms-static-page-view .accordion-section-title").removeClass("active");
    });
});
